var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M80 24L36 68L16 48","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Check;

Check.default = Check;
